// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app .city .app-main-page {\n  height: calc(100vh - 100px);\n}\n#app .hasTagsView .city .app-main-page {\n  height: calc(100vh - 130px);\n}\n", ""]);
// Exports
module.exports = exports;
